import { ResponsiveCalendar } from "@nivo/calendar";

function findEarliestAndLatestDates(datesArray) {
  try {
    // Check if array is empty
    if (!datesArray || datesArray.length === 0) {
      return {
        earliest: "2020-01-01",
        latest: "2020-01-01",
      };
    }
    // Validate dates and find min/max
    const validDates = datesArray
      .filter(([d]) => !isNaN(new Date(d).getTime()))
      .map(([dateStr]) => {
        const dateObj = new Date(dateStr);
        return dateObj;
      });

    const originalEarliest = new Date(Math.min(...validDates));
    const latest = new Date(Math.max(...validDates));

    // Calculate year difference
    const yearDiff = latest.getFullYear() - originalEarliest.getFullYear();
    let adjustedEarliest;
    if (yearDiff > 3) {
      // Create new date two years before latest
      const targetYear = latest.getFullYear() - 1;
      adjustedEarliest = new Date(targetYear, 0, 1); // January 1st of that year
    } else {
      adjustedEarliest = originalEarliest;
    }
    // Format dates back to YYYY-MM-DD
    const formatIsoDate = (date) => date.toISOString().split("T")[0];

    return {
      earliest: formatIsoDate(adjustedEarliest),
      latest: formatIsoDate(latest),
    };
  } catch {
    return {
      earliest: null,
      latest: null,
    };
  }
}

export const NivoCalendar = ({ data, colors }) => {
  const transformedData = (data || [])
    .slice(1)
    .map(([day, value]) => ({ day, value }));
  let { earliest, latest } = findEarliestAndLatestDates(data);
  if (!earliest || !latest) return null;
  return (
    <div
      className="calendar-chart-container"
      style={{ width: "100%", height: 230 }}
    >
      <ResponsiveCalendar
        data={transformedData}
        from={earliest}
        to={latest}
        emptyColor="#898b90"
        colors={["#66cc66", "#b8cc66", "#cc8f66", "#cc6666"]}
        margin={{ left: 30, right: 10 }}
        yearSpacing={20}
        monthBorderColor="#333"
        dayBorderWidth={2}
        dayBorderColor="#333"
        theme={{
          textColor: "#fff",
          axis: {
            ticks: {
              text: {
                fill: "#fff",
                fontFamily: '"Exo", sans-serif',
              },
            },
            legend: {
              text: {
                fill: "#fff",
                fontFamily: '"Exo", sans-serif',
              },
            },
          },
          legends: {
            text: {
              fill: "#fff",
              fontFamily: '"Exo", sans-serif',
            },
          },
          labels: {
            text: {
              fill: "#fff",
              fontFamily: '"Exo", sans-serif',
            },
          },
          tooltip: {
            container: {
              background: "#333",
              color: "#fff", // Set tooltip text color to black
              fontFamily: '"Exo", sans-serif',
            },
          },
        }}
      />
    </div>
  );
};

export default NivoCalendar;
